<template>
    <div class="muven-container">
        <div class="muven-router-name-container">
            <p class="muven-router-name">
                <span v-show="!loading && !brandForm.hasId()">Nova</span>
                <span v-show="!loading && brandForm.hasId()">Edição de</span>
                <span> Marca</span>
            </p>
        </div>

        <div class="muven-content">
            <Breadcrumb :items="breadcrumbList" v-show="!loading" class="mb-3"/>

            <Loading page v-show="loading" />

            <div v-show="!loading">
                <div class="muven-tip muven-tip-standalone tip-danger mb-3" v-show="brandForm.hasIdSource()">
                    <fa icon="info" class="tip-icon" />
                    <p>Esta marca foi cadastrada pela retaguarda, portanto não pode ser alterada.</p>
                </div>

                <div class="muven-card muven-card-md muven-card-centered">
                    <div class="muven-card-loading" v-show="submittingBrand">
                        <div class="muven-card-loading-message-container">
                            <p class="loading-message">
                                <fa class="loading-icon" icon="sync-alt" spin />
                            </p>
                        </div>
                    </div>

                    <div class="muven-card-title">
                        <p>{{brandForm.name | infoOrPlaceholder}}</p>
                    </div>

                    <div>
                        <div class="row">
                            <div class="col-12 form-group">
                                <label>Nome</label>
                                <input type="text" 
                                    class="form-control"
                                    v-model="brandForm.name" />
                            </div>

                            <div class="col-12 form-group">
                                <label>Descrição</label>
                                <input type="text" 
                                    class="form-control"
                                    v-model="brandForm.description" />
                            </div>

                            <div class="col-12 col-md-6">
                                <SwitchToggle 
                                    :prop-check="brandForm.isActive"
                                    :label-checked="'Ativa'"
                                    :label-unchecked="'Inativa'"
                                    @updated="isActiveHandler"
                                />

                                <SwitchToggle 
                                    :prop-check="brandForm.allowExport"
                                    :label-checked="'Exportar para os canais'"
                                    :label-unchecked="'Exportar para os canais'"
                                    @updated="allowExportHandler"
                                />
                            </div>
                        </div>

                        <div class="muven-card-actions">
                            <button class="btn btn-primary"
                                :disabled="submittingBrand || !brandForm.isValid() || brandForm.hasIdSource()"
                                @click="submitBrand(brandForm)">
                                Gravar

                                <Loading v-show="submittingBrand" />
                            </button>
                        </div>
                    </div>
                </div>
            </div>
        </div>
    </div>
</template>

<script>
import brandService from '../services/BrandService'
import { infoOrPlaceholder } from '@/utils/filters/InformationOrPlaceholderFilter'
import SelectWrapperCmp from '@/utils/components/SelectWrapperCmp'
import { BrandFormModel } from '../models/BrandFormModel'

export default {
    name: 'BrandFormView',
    data() {
        return {
            loading: true,
            submittingBrand: false,
            brandForm: new BrandFormModel(),
            breadcrumbList: [],
        }
    },
    components: {
        SelectWrapperCmp,
    },
    filters: {
        infoOrPlaceholder,
    },
    methods: {
        async submitBrand(brand) {
            this.$floatingAlert.hide()
            
            this.submittingBrand = true
            
            try {
                const brandFromServer = await brandService.createOrUpdateBrand(brand)

                this.$router.push(`/marcas/${brandFromServer.id}`)

                if (!brand.hasId()) {
                    this.$floatingAlert.success({
                        message: `Marca <b>${brand.name}</b> criada com sucesso!`,
                    })
                } else {
                    this.$floatingAlert.success({
                        message: `Marca <b>${brand.name}</b> modificada com sucesso!`,
                    })
                }
            } catch (err) {
                this.$floatingAlert.error({
                    message: err.message,
                })
            }

            this.submittingBrand = false
        },
        isActiveHandler(info) {
            this.brandForm.isActive = info
        },
        allowExportHandler(info) {
            this.brandForm.allowExport = info
        },
    },
    async mounted() {
        try {
            if (!!this.$route.params.id) {
                const brand = await brandService.getBrandById(this.$route.params.id)

                this.brandForm = new BrandFormModel(brand)

                this.breadcrumbList = [
                    {
                        id: 0,
                        description: 'Marcas',
                        path: '/marcas',
                    },
                    {
                        id: 1,
                        description: 'Detalhes',
                        path: `/marcas/${this.brandForm.id}`,
                    },
                    {
                        id: 1,
                        description: `Edição de #${this.brandForm.id}`,
                        path: '',
                    },
                ]
            } else {
                this.breadcrumbList = [
                    {
                        id: 0,
                        description: 'Marcas',
                        path: '/marcas',
                    },
                    {
                        id: 1,
                        description: 'Nova marca',
                        path: '',
                    },
                ]
            }
        } catch (err) {
            this.$floatingAlert.error({
                message: err.message,
            })
        }

        this.loading = false
    },
}
</script>



